import { render, staticRenderFns } from "./TemplateExportModal.vue?vue&type=template&id=15ca6130&scoped=true"
import script from "./TemplateExportModal.vue?vue&type=script&lang=js"
export * from "./TemplateExportModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateExportModal.vue?vue&type=style&index=0&id=15ca6130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca6130",
  null
  
)

export default component.exports